/** YYYY-MM-DD in the browser’s local calendar (same as existing “Today” filter). */
export function ymdLocal(d) {
  const x = d instanceof Date ? d : new Date(d);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`;
}

/**
 * Monday–Sunday week that contains `ref` (local calendar).
 * @returns {{ dateFrom: string, dateTo: string }}
 */
export function thisWeekDateRange(ref = new Date()) {
  const d = new Date(ref);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay();
  const mondayOffset = day === 0 ? -6 : 1 - day;
  const start = new Date(d);
  start.setDate(d.getDate() + mondayOffset);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  return { dateFrom: ymdLocal(start), dateTo: ymdLocal(end) };
}

/**
 * First and last day of the calendar month containing `ref` (local).
 * @returns {{ dateFrom: string, dateTo: string }}
 */
export function thisMonthDateRange(ref = new Date()) {
  const r = ref instanceof Date ? ref : new Date(ref);
  const start = new Date(r.getFullYear(), r.getMonth(), 1);
  const end = new Date(r.getFullYear(), r.getMonth() + 1, 0);
  return { dateFrom: ymdLocal(start), dateTo: ymdLocal(end) };
}

/**
 * Maps UI `filters.date` / `filters.selectedDate` / `filters.dateFrom` / `filters.dateTo`
 * to Odoo list API fields.
 *
 * Modes:
 *   - "today" | "this_week" | "this_month" — preset windows (local calendar)
 *   - "custom"       — single day → `{ selectedDate }`
 *   - "custom_range" — user-picked range → `{ dateFrom, dateTo }` (either bound optional)
 *
 * @param {{ date: string, selectedDate?: string|null, dateFrom?: string|null, dateTo?: string|null }} filters
 * @returns {{ selectedDate?: string, dateFrom?: string, dateTo?: string }}
 */
export function listDateFilterPayload(filters) {
  if (!filters || typeof filters !== "object") return {};

  if (filters.date === "today") {
    return { selectedDate: ymdLocal(new Date()) };
  }
  if (filters.date === "custom" && filters.selectedDate) {
    const d = String(filters.selectedDate).trim();
    if (!d) return {};
    return { selectedDate: d };
  }
  if (filters.date === "custom_range") {
    const from = String(filters.dateFrom || "").trim();
    const to = String(filters.dateTo || "").trim();
    const payload = {};
    if (from) payload.dateFrom = from;
    if (to) payload.dateTo = to;
    return payload;
  }
  if (filters.date === "this_week") {
    return thisWeekDateRange();
  }
  if (filters.date === "this_month") {
    return thisMonthDateRange();
  }
  return {};
}
